import React from 'react';
import classnames from 'classnames';
import {getCategory} from '../models';

const WorkflowCategoryChip = ({category, size}) => {
  const categoryData = getCategory(category);
  const classes = {
    'workflow-category-chip': true,
    [size || "md"]: true,
    [categoryData.colorName]: true
  };

  return (
    <span className={classnames(classes)}>
      <i className={`ss-icon ss-${categoryData.iconClass}`} />
    </span>
  );
}
export default WorkflowCategoryChip;
